import { RootState, ApplicationDirtyStateModel, StoreConstants } from '@/types';
import { ActionTree } from 'vuex';

export const actions: ActionTree<ApplicationDirtyStateModel, RootState> = {
  [StoreConstants.ApplicationDirty.Actions.ResetApplicationDirtyState]({ commit }) {
    commit(StoreConstants.ApplicationDirty.Mutations.ResetApplicationDirtyState);
  },
  [StoreConstants.ApplicationDirty.Actions.SetApplicationDirty]({ commit }, isApplicationDirty: boolean) {
    commit(StoreConstants.ApplicationDirty.Mutations.SetApplicationDirty, isApplicationDirty ?? true);
  },
  [StoreConstants.ApplicationDirty.Actions.SetApplicationDirtyOnAnotherTab]({ commit }, isApplicationDirty: boolean) {
    commit(StoreConstants.ApplicationDirty.Mutations.SetApplicationDirtyOnAnotherTab, isApplicationDirty);
  },
  [StoreConstants.ApplicationDirty.Actions.SetShowApplicationDirtyModal]({ commit }, show: boolean) {
    commit(StoreConstants.ApplicationDirty.Mutations.SetShowApplicationDirtyModal, show);
  },
  [StoreConstants.ApplicationDirty.Actions.SetApplicationDirtyOnModal]({ commit }, isDirty: boolean) {
    commit(StoreConstants.ApplicationDirty.Mutations.SetApplicationDirtyOnModal, isDirty);
  },
  [StoreConstants.ApplicationDirty.Actions.SetApplicationDirtyRouteNavigatedTo]({ commit }, to: any) {
    commit(StoreConstants.ApplicationDirty.Mutations.SetApplicationDirtyRouteNavigateTo, to);
  }
};
